import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { mergeMap, catchError, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { ETasksActions, GetTasks, AddTasks, AddTaskForSubUser } from '../actions/tasks.action';
import { of } from 'rxjs';
import { TasksService } from '../../Services/Tasks/tasks.service';


@Injectable()
export class TasksEffects {

    getTasks$ = createEffect(() => this.actions$.pipe(
        ofType<GetTasks>(ETasksActions.GetTasks),
        map(action => action.payload),
        mergeMap((payload : any) => this.tasksService.getTasks(payload)
        .pipe(map((result: any) => ({ type: '[Tasks] Set Tasks Details', payload: result })),
          catchError((err) => of({ type: 'Set Tasks Error', payload:err, from: 'getTasks' }))
        )
      )
    ));

    addTasks$ = createEffect(() => this.actions$.pipe(
        ofType<AddTasks>(ETasksActions.AddTasks),
        map(action => action.payload),
        mergeMap((payload : any) => this.tasksService.addTasksForMasterUserAndSubUser(payload)
        .pipe(map((result: any) => ({ type: 'Set Tasks Success', payload: result, from: 'AddTasks' })),
          catchError((err) => of({ type: 'Set Tasks Error', payload:err, from: 'AddTasks' }))
        )
      )
    ));

    addTasksForSubUser$ = createEffect(() => this.actions$.pipe(
        ofType<AddTaskForSubUser>(ETasksActions.AddTaskForSubUser),
        map(action => action.payload),
        mergeMap((payload : any) => this.tasksService.addTasksForSubUser(payload)
        .pipe(map((result: any) => ({ type: '[Tasks] Get Add Task For SubUser Success', payload: result})),
          catchError((err) => of({ type: '[Tasks] Get Add Task For SubUser Error', payload:err }))
        )
      )
    ));
    constructor( private actions$: Actions,
        private store: Store<IAppState>,
        private tasksService: TasksService
    ){}
}
